import { RoleModel } from './../../../model/usuario/role.model';
import { PermissionModel } from './../../../model/permission/permission.model';
import { GrupoPermissionModel } from './../../../model/permission/grupopermission.model';
import { PermissionsService } from './../../../service/permission/permissions.service';
import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-grupo-permissao',
  templateUrl: './grupo-permissao.component.html',
  styleUrls: ['./grupo-permissao.component.scss'],
})
export class GrupoPermissaoComponent implements OnInit {
  grupoPermissao = {} as GrupoPermissionModel;
  gruposPermissoes: GrupoPermissionModel[];
  permissao = {} as PermissionModel;
  permissoes: PermissionModel[];
  listaPermissionVazia = false;
  idGrupoExcluir: number;
  edited = false;
  add = false;
  editado = false;
  errorAlert = false;
  successDelete = false;
  grupoExcluir = {} as GrupoPermissionModel;
  nameGrupoExcluir: string;
  blockButtonExcluir = true;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private permissionService: PermissionsService
  ) {}

  ngOnInit() {
    this.listAllGrupos();
  }

  listGruposPermissoes() {
    this.permissionService.getGruposPermissions().subscribe(
      (data) => {
        this.gruposPermissoes = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getGrupo(grupo: GrupoPermissionModel) {
    this.grupoExcluir = { ...grupo};
    this.nameGrupoExcluir = this.grupoExcluir.name;
    this.blockButtonExcluir = false;
  }

  permissoesPorGrupos(roleId: number) {
    this.permissionService.getPermissionsGrupo(roleId).subscribe(
      (data) => {
        this.permissoes = data;
        this.idGrupoExcluir = roleId;
        if (this.permissoes.length > 0) {
          this.listaPermissionVazia = true;
        }
      },
      (err) => {
        this.idGrupoExcluir = roleId;
        this.listaPermissionVazia = false;
        console.error(err);
      }
    );
  }

  permissionByIdGrupo(grupoId: number) {
    this.permissionService.getPermissionByIdGrupo(grupoId).subscribe(data => {
      console.log(data);
    }, err => {
      console.log(err);
    });
  }

  listAllGrupos() {
    this.permissionService.getAllGrupos().subscribe(
      (data) => {
        this.gruposPermissoes = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  confirmeExcluir(id: number) {
    const confirme = confirm(`Deseja excluir o grupo de permissão: ${this.nameGrupoExcluir} ?`);
    if (confirme === true) {
      this.deleteGrupo(id);
    } else {
      console.log('Cancelou exclusão!');
    }
  }

  deleteGrupo(id: number) {
    this.permissionService.apagarGrupo(id).subscribe(
      (data) => {
        this.grupoPermissao = new GrupoPermissionModel();
        this.listAllGrupos();
        this.openSnackBarSuccess('Grupo de Permissão excluído com sucesso !');
        this.router.navigate(['grupo-permissao']);
      },
      (err) => {
        console.error(err);
        this.openSnackBarError('Erro ao tentar excluir o Grupo de Permissão !');
      }
    );
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/permissions/grupo-permissao/grupo-permissao.component.ts